export default ({ COLORS }) => ({
  hint: {
    color: COLORS.TEXT.LIGHT_GREY.NORMAL,
    marginTop: '20px !important'
  }
})
